// extracted by mini-css-extract-plugin
module.exports = {"container":"Introduction_container__24FUL","title":"Introduction_title__3jOfA","titleBold":"Introduction_titleBold__2JnQ5","description":"Introduction_description__gcGXV"};